import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WorkoutActivity } from '../../models/types';
import { SurfaceCard, CardRow } from '../../components/ui/SurfaceCard';
import { EmptyState } from '../../components/ui/EmptyState';
import { ActivityKindIcon, activityKindOf, formatPace, formatWhen, speedKmh } from '../../components/activities/activityHelpers';

export const RecentActivitiesCard = ({ activities }: { activities: WorkoutActivity[] }) => {
  const { t } = useTranslation('home');
  return (
  <SurfaceCard
    title={t('recentActivities.title')}
    action={<Box component={RouterLink} to="/activities" sx={{ fontSize: 13, color: 'var(--primary)', textDecoration: 'none' }}>{t('recentActivities.seeAll')}</Box>}
    bodyPadding={0}
    sx={{ overflow: 'hidden' }}
  >
    {activities.length === 0 ? (
      <Box sx={{ borderTop: '1px solid var(--border)' }}>
        <EmptyState title={t('recentActivities.emptyTitle')} description={t('recentActivities.emptyDescription')} />
      </Box>
    ) : (
      activities.map(a => {
        const kind = activityKindOf(a.workoutType);
        const secondary = kind === 'Ride' ? `${speedKmh(a.distance, a.movingTime).toFixed(1)} km/h` : `${formatPace(a.pace)} /km`;
        return (
          <CardRow key={a._id}>
            <Box sx={{ width: 36, height: 36, flex: 'none', borderRadius: '9px', backgroundColor: 'var(--muted-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>
              <ActivityKindIcon kind={kind} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <Box sx={{ fontSize: 14, fontWeight: 500 }}>{a.workoutType}</Box>
              <Box sx={{ fontSize: 12, color: 'var(--muted)' }}>{formatWhen(a.startDate)}</Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px', fontVariantNumeric: 'tabular-nums' }}>
              <Box sx={{ fontSize: 14, fontWeight: 600 }}>{a.distance.toFixed(1)} km</Box>
              <Box sx={{ fontSize: 12, color: 'var(--muted)' }}>{secondary}</Box>
            </Box>
          </CardRow>
        );
      })
    )}
  </SurfaceCard>
  );
};
